import type { PageLoad } from './$types';

export const load: PageLoad = ({ params }) => {
  return {
    meta: {
      title: 'Users',
      activeNav: 'users',
      breadcrumbs: {
        activeTitle: 'Users',
        items: [],
      },
    },
  };
};
